<template>
  <generic-modal
    v-if="showSubCategory"
    @close.stop="closeSubCategoryModal($event, '')"
    :width="subCategoryModalDim.width"
    :modalClass="subCategoryModalDim.modalClass"
    :animationStyle="subCategoryModalDim.animationStyle"
    :height="subCategoryModalDim.height"
    :overflowNotNeeded="0"
    :genericModalSource="'customizationModal'"
  >
    <template v-slot:header>
      <div class="slide-handle"></div>
      <span class="d-flex justify-content-right">
        <i
          @click.stop="closeSubCategoryModal($event, 'cross')"
          class="hkfi-close cm-close"
        ></i>
      </span>
    </template>
    <template v-slot:body>
      <div class="sub-category-customization-pop-content">
        <h3 class="fs-16 bold mb16">Choose Sub Category</h3>
        <!-- product customization card -->
        <div
          v-for="(item, index) in getSubCategoryData"
          :key="index"
          :label="item?.nodeName"
          class="mb8"
        >
          <div
            class="sub-category-name"
            v-on:click="handleSubCategoryClick(item, $event, index)"
          >
            <span>{{ item?.nodeName }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div></div>
    </template>
  </generic-modal>
</template>

<script>
import { computed } from "@vue/runtime-core";
import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";
import CustomLabelRadio from "./CustomLabelRadio.vue";
import Utility from "../helpers/utility";
export default {
  name: "SubCategoryModal",
  props: ["moduleProps", "dataProps"],
  components: {
    CustomLabelRadio,
  },
  data() {
    return {
      subCategoryModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "tnc-modal full-screen-popup lg-screen-centered",
      },
    };
  },
  methods: {
    closeSubCategoryModal(e, source = "") {
      e.stopPropagation();
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_SUB_CATEGORY_MODAL, false);
    },
    handleSubCategoryClick(item, e, index) {
      //@todo:- add nodeId instead of parentNodeId - done
      this.goto({ index, nodeId: item?.nodeId });
      this.closeSubCategoryModal(e);
    },
    goto({ index, nodeId, categoryName }) {
      Utility.gotoElement({ id: nodeId });
    },
  },
  computed: {
    showSubCategory() {
      return this.$store.state.ProductItems.showSubCategoryModal;
    },
    getSubCategoryData() {
      return this.$store.getters[keyMapsGetter.GET_SUB_CATEGORY_MODAL_DATA];
    },
  },
};
</script>

<style></style>
